<template>
  <v-dialog v-model="dialog" max-width="700" @click:outside="cancel">
    <v-card flat v-if="!_.isEmpty(filter)">
      <loading-spinner v-if="loading"></loading-spinner>
      <v-container v-else class="py-0">
        <v-btn icon @click="cancel" class="close-button">
          <v-icon>close</v-icon>
        </v-btn>
        <v-row>
          <v-col cols="12" sm="5" class="px-0 background">
            <v-card-title>
              <v-icon
                v-if="filter.breakdownId == 'department' && filter.id"
                class="mr-2"
                color="secondary"
              >
                business
              </v-icon>
              {{ detail.teamName }}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-title>
              {{ detail.name }}
            </v-card-title>
            <v-card-text class="secondary--text">
              {{ detail.description }}
              <v-row dense>
                <v-col cols="auto" class="text-h3">
                  {{ detail.score.value | one_decimal }}
                </v-col>
                <v-col cols="auto" class="caption" v-if="filter.id">
                  <div :class="color(detail.score) + '--text'">
                    <v-icon :color="color(detail.score)">
                      {{ icon(detail.score) }}
                    </v-icon>
                    {{ detail.score.difference | one_decimal }}
                  </div>
                  <div>
                    {{ detail.score.compare | one_decimal }}
                    {{ companies ? "Overall Average" : "Company Average" }}
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text
              class="secondary--text border-left--secondary border-left--3"
            >
              <div>
                Activity
                <v-icon x-small color="secondary">directions_bike</v-icon>
              </div>
              <div>
                {{ detail.totalResponses }} responses have been collected
              </div>
              <div>
                {{ detail.totalUserResponses }} of
                {{ detail.totalUsers }} members have contributed
              </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
              <v-row dense>
                <v-col
                  class="subtitle-1 mb-2"
                  v-bind:style="{
                    color: $coreScores.getColor(
                      $coreScores.reverseFormat(detail.confidenceScore)
                    )
                  }"
                >
                  <span class="font-weight-bold secondary--text">Status: </span>
                  {{ confidenceText(detail.confidenceScore) }}
                </v-col>
                <v-spacer class="limited-spacer"></v-spacer>
                <v-col cols="auto">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        color="lighttext"
                        small
                        class=" ml-2"
                      >
                        help
                      </v-icon>
                    </template>
                    <div class="tooltip-limit-width">
                      {{ confidenceHelpText(detail.confidenceScore) }}
                    </div>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-progress-linear
                class="rounded-pill my-auto elevation-1"
                :value="detail.confidenceScore"
                background-color="white"
                :color="
                  $coreScores.getColor(
                    $coreScores.reverseFormat(detail.confidenceScore)
                  )
                "
                height="16"
              ></v-progress-linear>
            </v-card-text>
          </v-col>
          <v-divider vertical></v-divider>
          <v-col cols="12" sm="7" class="px-0 mr-n1">
            <v-card-text>
              {{ detail.name }} has the following questions within it.
              <v-row class="overflow-row">
                <v-col cols="12" v-for="(item, i) in detail.questions" :key="i">
                  <pulse-heatmap-item-card
                    :item="item"
                    :hide-difference="!filter.id"
                  ></pulse-heatmap-item-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import PulseHeatmapItemCard from "@/components/pulse/PulseHeatmapItemCard";
import reports from "@/helpers/mixins/reports";
export default {
  name: "PulseHeatmapDialog",
  components: { PulseHeatmapItemCard },
  props: {
    companies: { type: Boolean, default: false }
  },
  mixins: [reports],
  data: () => ({
    dialog: false,
    loading: false,
    filter: {}
  }),
  watch: {},
  computed: {
    icon() {
      return score => {
        if (score.difference == 0) {
          return "remove";
        }
        return score.difference > 0 ? "arrow_drop_up" : "arrow_drop_down";
      };
    },
    color() {
      return score => {
        if (score.difference == 0) {
          return "lighttext";
        }
        return score.difference > 0 ? "success" : "error";
      };
    },
    ...mapGetters({ detail: "reporting/heatmap_detail" })
  },
  methods: {
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    showDialog(filter) {
      this.dialog = true;
      this.filter = this._.cloneDeep(filter);
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.$store
        .dispatch(
          this.companies
            ? "reporting/getPulseCompanyHeatmapDetail"
            : "reporting/getPulseHeatmapDetail",
          this.filter
        )
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading pulse heatmap detail."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-dialog {
  overflow: hidden;
}

.overflow-row {
  overflow-y: auto;
  max-height: 430px;
}

.close-button {
  position: absolute;
  right: 0;
}
</style>
